// extracted by mini-css-extract-plugin
module.exports = {"signInForm":"signin_signInForm__3Ln2W"};